module.exports = __webpack_public_path__ + "img/info2.7107cf85.svg";